import { ConfigurationHeaderWrapper } from '../../../_components/configuration-header-wrapper.component'
import { useTranslation } from 'react-i18next'
import { EContentType } from '../../_components/content.type'
import { AddContentForm } from '../../_components/content-forms.component'

export default function AddExternalLinkContentPage() {
  const { t } = useTranslation()

  return (
    <ConfigurationHeaderWrapper title={t('pages.configuration.contents.add-external-link')}>
      <p className="c-text-grey-600 c-font-nexa c-font-light c-text-sm">
        {t('pages.configuration.contents.start-to-select-language-external-link')}
      </p>
      <AddContentForm contentType={EContentType.EXTERNAL_LINK} />
    </ConfigurationHeaderWrapper>
  )
}
